// client/src/utils/api/settings.js

import { api, handleRequestError } from './config';
import { getLogger } from "@/utils/logger";

const log = getLogger("settings");


/**
 * Get system settings
 * @returns {Promise<Object>} System settings
 */
export const getSystemSettings = async () => {
  try {
    const response = await api.get('/settings');
    return response.data;
  } catch (error) {
    handleRequestError(error, "Failed to fetch system settings");
  }
};


/**
 * Get public-facing system settings (no auth required)
 * @returns {Promise<Object>} Public system settings
 */
export const getPublicSystemSettings = async () => {
  try {
    const response = await api.get('/settings/public');
    return response.data;
  } catch (error) {
    handleRequestError(error, "Failed to fetch public system settings");
  }
};

/**
 * Update system settings
 * @param {Object} settingsData - Updated settings
 * @returns {Promise<Object>} Updated settings
 */
export const updateSystemSettings = async (settingsData) => {
  try {
    const response = await api.put('/settings', settingsData);
    return response.data;
  } catch (error) {
    handleRequestError(error, "Failed to update system settings");
  }
};

/**
 * Test SMTP connection
 * @param {Object} smtpData - SMTP configuration
 * @returns {Promise<Object>} Test results
 */
export const testSmtpConnection = async (smtpData) => {
  try {
    const response = await api.post('/settings/test-smtp', smtpData);
    return response.data;
  } catch (error) {
    log.error(
      `[settings:testSmtpConnection] > [Request]: POST /settings/test-smtp > [Response]: error=${error?.message || "unknown"}`
    );
    throw error;
  }
};
